import sanitizeHTML from 'sanitize-html'

export const sanitize = (value: string | object | unknown[] | unknown): any => {
  if (typeof value === 'string') {
    return sanitizeHTML(value)
  } else if (Array.isArray(value)) {
    return value.map(sanitize)
  } else if (typeof value === 'object' && value !== null) {
    const sanitizedObject: Record<string, unknown> = {}
    for (const key in value) {
      if (value.hasOwnProperty(key)) {
        sanitizedObject[key] = sanitize((value as Record<string, unknown>)[key])
      }
    }
    return sanitizedObject
  }
  return value
}
